import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let moduleEl = this.el;
        console.log(moduleEl.href)

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        const isAndroid = /android/i.test(userAgent);

        if (isIOS || isAndroid) {
            moduleEl.href = moduleEl.href.replace('https://', 'webcal://');
        }
    }
}